import {Button, Stack, Typography} from '@mui/material';
import React, {Fragment} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import operationalCostImg from 'presentation/assets/images/medical-consultation.svg';
import {MainHeader} from 'presentation/components';
import {ChatRoomsEnum, HomeEnum} from 'presentation/constants';
import {useCallChatRoom} from 'presentation/pages/private/hooks';
import {ServicesTypesEnum} from 'presentation/pages/private/services/types';
import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {translations} from 'presentation/translations-new';
import {StyledCard, StyledContainer, StyledImage} from './styles';
import {Loading} from 'presentation/components/Loading/Loading';

const {buttonChat, buttonGoHome, subtitle, title} =
	translations['pt-br'].privateFlow.operationalCost.noPassword;
const {telehealthTitle, emergencyTitle, authorizationsTitle, healthTitle, examTitle, odontoTitle} =
	translations['pt-br'].privateFlow.operationalCost.headerTitles;

export function OperationalCostNoPassword() {
	const navigate = useNavigate();
	const {state} = useLocation() as {state: {type: ServicesTypesEnum}};
	const {callChatRoom, IS_LOADING: callChatRoomIsLoading} = useCallChatRoom();
	const {sidebar} = useAccountDataStore(store => store.accountData);
	const operationalCostDescription = sidebar.ctOperacional?.mensagem;

	const headerTitle: Record<ServicesTypesEnum, string> = {
		[ServicesTypesEnum.HEALTH]: healthTitle,
		[ServicesTypesEnum.TELEHEALTH]: telehealthTitle,
		[ServicesTypesEnum.EXAMS]: examTitle,
		[ServicesTypesEnum.ODONTO]: odontoTitle,
		[ServicesTypesEnum.EMERGENCY_TELEHEALTH]: emergencyTitle,
		[ServicesTypesEnum.AUTHORIZATIONS]: authorizationsTitle,
		[ServicesTypesEnum.OTHERS]: '',
	};

	function handleBack() {
		navigate(HomeEnum.HOME_PAGE);
	}

	return (
		<Fragment>
			<MainHeader
				title={state?.type ? headerTitle[state.type] : title}
				handleBack={handleBack}
				variant="subRoute"
				hideClose
			/>
			<StyledContainer>
				<StyledCard elevation={0}>
					<Stack gap={2}>
						<Typography variant="h6">{subtitle}</Typography>
						<Typography color="text.secondary">{operationalCostDescription}</Typography>
						<Stack gap={1}>
							<Button onClick={handleBack} size="large">
								{buttonGoHome}
							</Button>

							<Button
								variant="outlined"
								fullWidth
								size="large"
								onClick={async () => await callChatRoom(ChatRoomsEnum.APP)}
								disabled={callChatRoomIsLoading}
								endIcon={
									callChatRoomIsLoading ? (
										<Loading size={16} color="inherit" />
									) : null
								}>
								{buttonChat}
							</Button>
						</Stack>
					</Stack>
					<StyledImage>
						<img src={operationalCostImg} alt="Médico avaliando paciente" />
					</StyledImage>
				</StyledCard>
			</StyledContainer>
		</Fragment>
	);
}
